import { put, select, take } from 'redux-saga/effects';

import { runAmountCalculations, SET_GRAND_TOTAL } from '../productCartHandler/productCartModule';
import { CONSUMER_FEES_FETCH_FAILED, requestConsumerFees, SET_CONSUMER_FEES } from '../fees/consumerFeeModule';
import { getIntlCurrencyCode } from '../intl/intlSelectors';
import { applyActivePromo, setPromoDiscountAmount } from '../promo/promoModule';
import { getIsBuyNowFlow } from '../routing/routingSelectors';

import { getFeesCurrencyCode } from '../fees/consumerFeeSelectors';
export default function* paymentDependencySaga() {
    const currencyCode = yield select(getIntlCurrencyCode);
    const isBuyNow = yield select(getIsBuyNowFlow);
    const feesCurrencyCode = yield select(getFeesCurrencyCode);

    
    
    if (currencyCode && (!feesCurrencyCode || feesCurrencyCode !== currencyCode)) {
        yield put(requestConsumerFees(currencyCode));
        
        yield take([SET_CONSUMER_FEES, CONSUMER_FEES_FETCH_FAILED]);
    }

    if (isBuyNow) {
        yield put(setPromoDiscountAmount(0));
    }

    
    yield put(runAmountCalculations());

    
    yield take(SET_GRAND_TOTAL);

    
    if (isBuyNow) {
        yield put(applyActivePromo());
    }
}
